import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockDataSourceChunkingStrategy,
  BedrockDataSourceConfluenceSecretARN,
  BedrockDataSourceKnowledgeBaseID,
  BedrockDataSourceParsingModelARN,
  BedrockDataSourceS3BucketARN,
  BedrockDataSourceS3InclusionPrefixes,
  BedrockDataSourceSalesforceSecretARN,
  BedrockDataSourceSharePointSecretARN,
  BedrockDataSourceType,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockKnowledgeBaseDataSourceMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {BedrockDataSourceType(metadata)}
      {BedrockDataSourceS3BucketARN(metadata)}
      {BedrockDataSourceS3InclusionPrefixes(metadata)}
      {BedrockDataSourceConfluenceSecretARN(metadata)}
      {BedrockDataSourceSalesforceSecretARN(metadata)}
      {BedrockDataSourceSharePointSecretARN(metadata)}
      {BedrockDataSourceChunkingStrategy(metadata)}
      {BedrockDataSourceParsingModelARN(metadata)}
      {BedrockDataSourceKnowledgeBaseID(metadata)}
    </Grid>
  );
};
